import React from 'react';
import { Preloader } from '@/components/Preloader';
import { useDownloadLink } from '@/hooks/useDownloadLink';

export const DownloadButton = ({ link, filename, preloaderClassname, children }) => {
  const [loading, setLoading] = React.useState(false);

  const { onDownload } = useDownloadLink();

  const handleDownload = async () => {
    try {
      setLoading(true);
      await onDownload({
        url: link,
        filename,
      });
    } finally {
      setLoading(false);
    }
  };

  return loading ? (
    <Preloader className={preloaderClassname} style={{ width: '50px' }} />
  ) : (
    <button type="button" onClick={handleDownload}>
      {children}
    </button>
  );
};
